import {useEffect, useRef, useState} from 'react';
import {SActionBtn, SBack, SLowcodeList, STableActions} from 'shj-components'
import {getAuth, iiHOC} from '@/utils/auth';
import config from './config.json';
import KeepAlive from 'react-activation';
import {useLocation, useNavigate} from 'react-router-dom'
import { businessMattersSearch,billSetInfoSearchList } from '@/services/integrationConfig'
import { Popconfirm, message } from 'antd';
import { modalAddOrEditFn } from './addOrEdit';
import { AccountSetsFn } from './accountSets';

function BusinessItemConfigDom() {
  const listRef = useRef<any>();
  const [billSetList, setBillSetList] = useState([]);
  // 表格加载
  const fetchList = (values: any) => {
    const { current, pageSize, ...rest } = values;
    return new Promise(async (resolve, reject) => {
      try {
        let data = await businessMattersSearch(current, pageSize, rest.query);
        resolve(data);
      } catch (e) {
        reject({ success: false });
      }
    });
  };
  // 新增/编辑
  const add = (obj = {}, title = '', isSee = false) => {
    modalAddOrEditFn({
      fn: () => {
        reloadFn();
      },
      ...obj,
      transferFlag: signArr.find((e) => e?.name === obj?.transferFlag)?.code || '',
      businessSystem: businessSystemArr.find((e) => e?.name === obj?.businessSystem)?.code || '',
      isSee,
      title,
    });
  };
  const onAdd =() => {
    add({}, '新增');
  };
  const onCopy = (record: Record<string, any>) => {
    add({ ...record, copy: true }, '复制', true);
  };
  // 刷新
  const reloadFn = () => {
    const {
      current: { reload },
    } = listRef;
    reload();
  };
  const getBillSetList = () => {
    billSetInfoSearchList({
      status: 1,
    }).then((resp: any) => {
      setBillSetList(resp || []);
    });
  };
  useEffect(() => {
    getBillSetList();
  }, []);
  const businessSystemArr = [
    { name: 'FMS', code: 'FMS' },
    { name: 'CRM', code: 'CRM' },
    { name: '供应链', code: 'SUPPLY_CHAIN' },
    { name: '交付', code: 'DELIVERY' },
    { name: 'OMS', code: 'OMS' },
    { name: 'WMS', code: 'WMS' },
    { name: 'HR', code: 'HR' },
    { name: '金蝶', code: 'KINGDEE' },
  ];
  const signArr = [
    { name: '只转不传', code: 'only_transfer' },
    { name: '只传不转', code: 'only_send' },
    { name: '又转又传', code: 'both_transfer_and_send' },
  ];
  const actionTypeArr = [
    { name: '新增', code: 'add' },
    { name: '提交', code: 'submit' },
    { name: '更新（要反审核）', code: 'update_with_review' },
    { name: '更新（不反审核）', code: 'update_without_review' },
    { name: '下推', code: 'push_down' },
    { name: '批量保存', code: 'batch_save' },
    { name: '批量下推', code: 'batch_push_down' },
    { name: '查询', code: 'query' },
    { name: '反确认', code: 'un_confirm' },
  ];
  const getStatusOptions = () => {
    return new Promise((resolve, reject) => {
      resolve({
        statusArr: [
          { name: '启用', code: true },
          { name: '禁用', code: false },
        ],
        businessSystemArr,
        signArr,
        actionTypeArr,
      });
    });
  };
  const extension = {
    request: { fetchList, getStatusOptions },
    events: { onAdd },
    customRender: {
      statusRender(text: any) {
        return <div>{text ? '启用' : '禁用'}</div>;
      },
      actionTypeRender(text: any) {
        return actionTypeArr.find((e) => e.code === text)?.name || '';
      },
      actionTool(text: any, record: any) {
        return iiHOC(
          <STableActions>
            <SActionBtn
              onClick={() => {
                add(record);
              }}
            >
              编辑
            </SActionBtn>
            <SActionBtn
              onClick={() => {
                add(record, '查看', true);
              }}
            >
              查看
            </SActionBtn>
            <SActionBtn
              onClick={() => {
                AccountSetsFn({
                  fn: () => {},
                  ...record,
                  billSetList,
                });
              }}
            >
              关联账套
            </SActionBtn>

            {/* <Popconfirm title={'确认删除？'} onConfirm={() => { onDel(record.id) }} okText="确定" cancelText="取消">
              <ActionBtn alarm>删除</ActionBtn>
            </Popconfirm> */}
            <SActionBtn
              onClick={() => {
                onCopy(record);
              }}
            >
              复制
            </SActionBtn>
          </STableActions>,
        );
      },
    },
  };

  return <><SBack title={`业务事项配置`}></SBack>
  <SLowcodeList config={config} ref={listRef} {...extension} searchMode="group" />
  </>
}
const BusinessItemConfig = (props: any) => {
  const location = useLocation()
  return (
    <KeepAlive name={location.pathname} id={'keep' + location.pathname}>
      <BusinessItemConfigDom {...props} />
    </KeepAlive>
  );
};
export default BusinessItemConfig;
